import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok } from 'react-icons/fa';

export const socialLinks = [
  {
    name: 'instagram',
    url: 'https://www.instagram.com/cif_up/',
    icon: <FaInstagram />,
  },
  {
    name: 'tiktok',
    url: 'https://www.tiktok.com/@cif_up',
    icon: <FaTiktok />,
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/company/cif-up/',
    icon: <FaLinkedin />,
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/profile.php?id=61550694992609',
    icon: <FaFacebook />,
  }
];
